<script setup lang="ts">
defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError
})

const closeTab = () => {
  window.close()
}
</script>

<template>
  <div class="flex flex-col w-full min-h-screen">
    <HeaderBar />

    <div class="flex flex-col flex-grow gap-4 items-center px-2 pt-20 w-full bg-secondary-20">
      <IError class="w-16 h-16" />
      <h1 class="text-[70px] font-bold text-center">
        {{ error.statusCode === 404 ? 'Seite nicht gefunden' : 'Etwas ist schief gelaufen' }}
      </h1>
      <div class="flex gap-4">
        <OFButton
          variant="secondary"
          class="mt-4 text-black !border !border-black"
          @click="closeTab"
        >
          Tab schließen
        </OFButton>
        <NuxtLink to="/">
          <OFButton
            variant="secondary"
            class="mt-4 text-black !border !border-black"
          >
            Zur Startseite
          </OFButton>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
